import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, reset } from 'redux-form'
import { Box } from 'grid-styled'
import FilterByPeriod from '../../modules/FilterByPeriod/FilterByPeriod'
import FilterByWeekDays from '../../modules/FilterByWeekDays/FilterByWeekDays'
import FilterByServices from './FilterByServices/FilterByServices'

import { ButtonsContainer, Separator, FormButton, ResetButton, ButtonsWrapper } from './styles'
import FilterByIdentifier from '../../pages/DashboardStatement/FilterByIdentifier/FilterByIdentifier'

class StatementsFilterForm extends Component {
  state = {
    weekRefs: [],
    servicesRefs: [],
    isFixed: true,
    hasValePedagio: false
  }

  setWeekDayRef = ref => this.setState({ weekRefs: [...this.state.weekRefs, ref] })
  setServicesRef = ref => this.setState({ servicesRefs: [...this.state.servicesRefs, ref] })

  unsetFilterByWeekDays = () => {
    this.state.weekRefs.map(ref => {
      ref.checked = false
    })
    this.setState({ weekRefs: [] })
  }

  unsetServices = () => {
    this.state.servicesRefs.map(ref => {
      ref.checked = false
    })
    this.setState({ servicesRefs: [] })
  }
  render() {
    const { handleSubmit, accountPlans, unsetResults, dispatch, accountId } = this.props

    return (
      <form onSubmit={handleSubmit} id="filter-form">
        <Box mb={50}>
          <FilterByIdentifier accountId={accountId} />
          <Separator />
          <FilterByPeriod />
          <FilterByWeekDays setWeekDayRef={this.setWeekDayRef} />
          <Separator />
          <FilterByServices
            setServicesRef={this.setServicesRef}
            activePlanId={accountPlans.activePlanId}
            setHasValePedagio={this.props.setHasValePedagio}
            hasValePedagio={this.props.hasValePedagio}
          />
          <ButtonsContainer>
            <ButtonsWrapper>
              <ResetButton
                onClick={e => {
                  e.preventDefault()
                  unsetResults()
                  this.unsetFilterByWeekDays()
                  this.unsetServices()
                  dispatch(reset('statementsFilter'))
                }}
              >
                Remover filtros
              </ResetButton>

              <FormButton type="submit">Aplicar filtros</FormButton>
            </ButtonsWrapper>
          </ButtonsContainer>
        </Box>
      </form>
    )
  }
}

export default reduxForm({
  form: 'statementsFilter',
  destroyOnUnmount: true
})(
  connect(state => ({
    accountPlans: state.reducer.accountPlans
  }))(StatementsFilterForm)
)



// WEBPACK FOOTER //
// ./src/app/modules/StatementsFilterForm/index.js